// returns a nicely formatted dollar amount string
// @params {amount} a number representing a dollar amount in cents

export function nicePrice(amount: number, decimals = 2) {
  let n: string;
  if (amount < 0) {
    n = (Math.round(amount) / 100 * -1).toFixed(
      decimals,
    );
    return `-$${n}`;
  } else {
    n = (Math.round(amount) / 100).toFixed(
      decimals,
    );

    // insert comma every 3 chars starting from end of string
    return `$${n.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
  }
}
